var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListagemBase',{attrs:{"nomePlural":"OperacoesPendentesTransacoes","nomeSingular":"OperacaoPendenteTransacao","headers":_vm.headers,"botaoCadastro":false,"customRowActions":_vm.customRowActions,"buscaSimplificada":false,"buscaParametrizadaPaginada":true,"pesquisaPeriodo":true,"pesquisaCpfCnpj":true,"pesquisaNome":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }